export default __webpack_public_path__ + "static/Istio Ingress Gateway No Title-0f1dfab6751856dedc649b56f3490fc1.webp";